<template>
  <div class="main">

    <div slot="header" class="clearfix">
      <span>2026年四川省级机关钓鱼比赛报名表</span>
    </div>
    <el-form :model="form" :rules="rules" ref="form" class="form-box">
      <el-form-item label="参赛类型" prop="cslx">
        <el-radio-group v-model="form.cslx" @change="handleTypeChange">
          <el-radio label="1">个人赛</el-radio>
          <el-radio label="0">团体赛</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 个人赛表单 -->
      <template v-if="form.cslx === '1'">
        <el-form-item label="单位名称" prop="team.dwmc">
          <el-input v-model="form.team.dwmc" placeholder="请输入单位名称"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="personal.name">
          <el-input v-model="form.personal.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="personal.gender">
          <el-radio-group v-model="form.personal.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" prop="personal.age">
          <el-input v-model.number="form.personal.age" placeholder="请输入年龄" type="number"></el-input>
        </el-form-item>
        <el-form-item :label="cszb == 'A' ? '原职务' : '职务'" prop="personal.duty">
          <el-input v-model="form.personal.duty" :placeholder="cszb == 'A' ? '请输入原职务' : '请输入职务'"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="personal.idCard">
          <el-input v-model="form.personal.idCard" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="personal.phone">
          <el-input v-model="form.personal.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="上衣尺码" prop="personal.sycm">
          <el-select style="width: 100%" v-model="form.personal.sycm" placeholder="请选择上衣尺码">
            <el-option v-for="(item, index) in optionList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

      </template>

      <!-- 团体赛表单 -->
      <template v-if="form.cslx === '0'">
        <el-form-item label="单位名称" prop="team.dwmc">
          <el-input v-model="form.team.dwmc" placeholder="请输入单位名称"></el-input>
        </el-form-item>
        <el-form-item label="领队" prop="team.leaderName">
          <el-input v-model="form.team.leaderName" placeholder="请输入领队姓名"></el-input>
        </el-form-item>
        <el-form-item label="领队电话" prop="team.leaderPhone">
          <el-input v-model="form.team.leaderPhone" placeholder="请输入领队电话"></el-input>
        </el-form-item>
        <el-form-item label="领队身份证号" prop="team.leaderIdCard">
          <el-input v-model="form.team.leaderIdCard" placeholder="请输入领队身份证号（选填）"></el-input>
        </el-form-item>
        <el-form-item label="工作人员" prop="team.workerName">
          <el-input v-model="form.team.workerName" placeholder="请输入工作人员姓名"></el-input>
        </el-form-item>
        <el-form-item label="工作人员电话" prop="team.workerPhone">
          <el-input v-model="form.team.workerPhone" placeholder="请输入工作人员电话"></el-input>
        </el-form-item>
        <el-form-item label="工作人员身份证号" prop="team.workerIdCard">
          <el-input v-model="form.team.workerIdCard" placeholder="请输入工作人员身份证号（选填）"></el-input>
        </el-form-item>

        <el-divider>参赛运动员</el-divider>
        <el-tabs v-model="activeTab">
          <el-tab-pane label="一号运动员" name="member1">
            <el-form-item label="姓名" prop="team.member1.name">
              <el-input v-model="form.team.member1.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="team.member1.gender">
              <el-radio-group v-model="form.team.member1.gender">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄" prop="team.member1.age">
              <el-input v-model.number="form.team.member1.age" placeholder="请输入年龄" type="number"></el-input>
            </el-form-item>
            <el-form-item :label="cszb == 'A' ? '原职务' : '职务'" prop="team.member1.duty">
              <el-input v-model="form.team.member1.duty" :placeholder="cszb == 'A' ? '请输入原职务' : '请输入职务'"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="team.member1.idCard">
              <el-input v-model="form.team.member1.idCard" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="team.member1.phone">
              <el-input v-model="form.team.member1.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="上衣尺码" prop="team.member1.sycm">
              <el-select style="width: 100%" v-model="form.team.member1.sycm" placeholder="请选择上衣尺码">
                <el-option v-for="(item, index) in optionList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="二号运动员" name="member2">
            <el-form-item label="姓名" prop="team.member2.name">
              <el-input v-model="form.team.member2.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="team.member2.gender">
              <el-radio-group v-model="form.team.member2.gender">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄" prop="team.member2.age">
              <el-input v-model.number="form.team.member2.age" placeholder="请输入年龄" type="number"></el-input>
            </el-form-item>
            <el-form-item :label="cszb == 'A' ? '原职务' : '职务'" prop="team.member2.duty">
              <el-input v-model="form.team.member2.duty" :placeholder="cszb == 'A' ? '请输入原职务' : '请输入职务'"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="team.member2.idCard">
              <el-input v-model="form.team.member2.idCard" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="team.member2.phone">
              <el-input v-model="form.team.member2.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="上衣尺码" prop="team.member2.sycm">
              <el-select style="width: 100%" v-model="form.team.member2.sycm" placeholder="请选择上衣尺码">
                <el-option v-for="(item, index) in optionList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="三号运动员" name="member3">
            <el-form-item label="姓名" prop="team.member3.name">
              <el-input v-model="form.team.member3.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="team.member3.gender">
              <el-radio-group v-model="form.team.member3.gender">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄" prop="team.member3.age">
              <el-input v-model.number="form.team.member3.age" placeholder="请输入年龄" type="number"></el-input>
            </el-form-item>
            <el-form-item :label="cszb == 'A' ? '原职务' : '职务'" prop="team.member3.duty">
              <el-input v-model="form.team.member3.duty" :placeholder="cszb == 'A' ? '请输入原职务' : '请输入职务'"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="team.member3.idCard">
              <el-input v-model="form.team.member3.idCard" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="team.member3.phone">
              <el-input v-model="form.team.member3.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="上衣尺码" prop="team.member3.sycm">
              <el-select style="width: 100%" v-model="form.team.member3.sycm" placeholder="请选择上衣尺码">
                <el-option v-for="(item, index) in optionList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>

          </el-tab-pane>
        </el-tabs>
      </template>

      <el-form-item>
        <el-button type="primary" style="width: 100%;background-color: #08DEDB;color:#272727;border-color: #08DEDB;"
          @click="submitForm">提交报名</el-button>
      </el-form-item>
      <p class="rulesBox"><el-checkbox v-model="isRead"></el-checkbox>我已阅读<span
          @click="dialogVisible = true">《参赛办法》</span>
      </p>
    </el-form>

    <el-dialog title="参赛办法" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" width="80%" class="notice-dialog">
      <div class="notice-content">
        <p class="notice-item">
          <span class="notice-label">(一)</span>
          省级机关体育协会会员单位均可组队参加，每个单位可按照A组（60周岁以上）、B 组（59周岁以下）年龄划分报名组队，每队可报领队1人、工作人员1人，运动员3人，组队不足3名运动员的单位可以报名参加个人赛。各单位报名参赛选手总人数不超过6人。
        </p>
        <p class="notice-item">
          <span class="notice-label">(二)</span>
          参赛运动员必须身体健康，适宜参加该项目比赛。参赛运动员须签署自愿参赛责任书，由各参赛队领队负责收集，比赛前在签到处交组委会协调组。
        </p>
        <p class="notice-item">
          <span class="notice-label">(三)</span>
          为确保比赛安全顺利，减轻各单位组队参赛的安全压力，参照国际国内钓鱼赛事的做法，由赛事组委会为每一名参赛运动员及领队和工作人员提供一份比赛期间人身意外保险。身份证信息用于统一购买意外伤害保险，如未填报，视作自动放弃投保。
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" style="width: 48%;" @click="confirmGroup('A')">已阅确定选 A 组</el-button>
        <el-button type="primary" style="width: 48%;" @click="confirmGroup('B')">已阅确定选 B 组</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from "@/api/index"
export default {
  name: 'IndexCom',
  data() {
    const memberTemplate = {
      name: '',
      gender: '',
      age: '',
      duty: '',
      idCard: '',
      phone: '',
      height: '',
      weight: ''
    }

    const validateMemberRequired = (memberPrefix, field) => {
      return (rule, value, callback) => {
        // 修复：判断条件改为 cslx === '1'
        if (this.form.cslx === '0') {
          const member = this.form.team[memberPrefix]
          if (!member || !member[field]) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }

    const validateMemberIdCard = (memberPrefix) => {
      return (rule, value, callback) => {
        if (this.form.cslx === '0') {
          const member = this.form.team[memberPrefix]
          if (!member.idCard) {
            callback(new Error(rule.message))
          } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(member.idCard)) {
            callback(new Error('请输入正确的身份证号码'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }

    // 非必填：为空时直接通过，填写时才校验身份证格式
    const validateIdCardOptional = (rule, value, callback) => {
      if (value === undefined || value === null || String(value).trim() === '') {
        callback()
      } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error('请输入正确的身份证号码'))
      } else {
        callback()
      }
    }

    const validateMemberPhone = (memberPrefix) => {
      return (rule, value, callback) => {
        if (this.form.cslx === '0') {
          const member = this.form.team[memberPrefix]
          if (!member.phone) {
            callback(new Error(rule.message))
          } else if (!/^1[3-9]\d{9}$/.test(member.phone)) {
            callback(new Error('请输入正确的手机号码'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }

    return {
      cszb: "A",
      dialogVisible: true,
      isRead: false,
      optionList: [
        { value: '1', label: 'S(尺码)-62(衣长)' },
        { value: '2', label: 'M(尺码)-64(衣长)' },
        { value: '3', label: 'L(尺码)-66(衣长)' },
        { value: '4', label: 'XL(尺码)-68(衣长)' },
        { value: '5', label: '2XL(尺码)-69(衣长)' },
        { value: '6', label: '3XL(尺码)-70(衣长)' },
        { value: '7', label: '4XL(尺码)-71(衣长)' },
        { value: '8', label: '5XL(尺码)-72(衣长)' },
        { value: '9', label: '6XL(尺码)-73(衣长)' },
        { value: '10', label: '7XL(尺码)-74(衣长)' },
      ],
      form: {
        cslx: '1',
        personal: {
          name: '',
          gender: '',
          age: '',
          duty: '',
          idCard: '',
          phone: '',
          height: '',
          weight: ''
        },
        team: {
          dwmc: '',
          leaderName: '',
          leaderPhone: '',
          leaderIdCard: '',
          workerName: '',
          workerPhone: '',
          workerIdCard: '',
          member1: { ...memberTemplate },
          member2: { ...memberTemplate },
          member3: { ...memberTemplate }
        }
      },
      activeTab: 'member1',
      rules: {
        cslx: [
          { required: true, message: '请选择参赛类型', trigger: 'change' }
        ],
        personal: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          gender: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
          age: [
            { required: true, message: '请输入年龄', trigger: 'blur' }
          ],
          duty: [
            { required: true, message: '请输入职务', trigger: 'blur' }
          ],
          idCard: [
            { required: true, message: '请输入身份证号码', trigger: 'blur' },
            { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号码', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          sycm: [
            { required: true, message: '请输入上衣尺码', trigger: 'blur' }
          ],
        },
        team: {
          dwmc: [
            { required: true, message: '请输入单位名称', trigger: 'blur' }
          ],
          leaderName: [
            { required: true, message: '请输入领队姓名', trigger: 'blur' }
          ],
          leaderPhone: [
            { required: true, message: '请输入领队电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          workerName: [
            { required: true, message: '请输入工作人员姓名', trigger: 'blur' }
          ],
          workerPhone: [
            { required: true, message: '请输入工作人员电话', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          leaderIdCard: [
            { validator: validateIdCardOptional, trigger: 'blur' }
          ],
          workerIdCard: [
            { validator: validateIdCardOptional, trigger: 'blur' }
          ],
          'team.member1.name': [
            { required: true, validator: validateMemberRequired('member1', 'name'), message: '请输入姓名', trigger: 'blur' }
          ],
          'team.member1.gender': [
            { required: true, validator: validateMemberRequired('member1', 'gender'), message: '请选择性别', trigger: 'change' }
          ],
          'team.member1.age': [
            { required: true, validator: validateMemberRequired('member1', 'age'), message: '请输入年龄', trigger: 'blur' }
          ],
          'team.member1.duty': [
            { required: true, validator: validateMemberRequired('member1', 'duty'), message: '请输入职务', trigger: 'blur' }
          ],
          'team.member1.idCard': [
            { required: true, validator: validateMemberIdCard('member1'), message: '请输入正确的身份证号码', trigger: 'blur' }
          ],
          'team.member1.phone': [
            { required: true, validator: validateMemberPhone('member1'), message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          'team.member1.sycm': [
            { required: true, validator: validateMemberRequired('member1', 'sycm'), message: '请输入上衣尺码', trigger: 'change' }
          ],
          'team.member2.name': [
            { required: true, validator: validateMemberRequired('member2', 'name'), message: '请输入姓名', trigger: 'blur' }
          ],
          'team.member2.gender': [
            { required: true, validator: validateMemberRequired('member2', 'gender'), message: '请选择性别', trigger: 'change' }
          ],
          'team.member2.age': [
            { required: true, validator: validateMemberRequired('member2', 'age'), message: '请输入年龄', trigger: 'blur' }
          ],
          'team.member2.duty': [
            { required: true, validator: validateMemberRequired('member2', 'duty'), message: '请输入职务', trigger: 'blur' }
          ],
          'team.member2.idCard': [
            { required: true, validator: validateMemberIdCard('member2'), message: '请输入正确的身份证号码', trigger: 'blur' }
          ],
          'team.member2.phone': [
            { required: true, validator: validateMemberPhone('member2'), message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          'team.member2.sycm': [
            { required: true, validator: validateMemberRequired('member2', 'sycm'), message: '请输入上衣尺码', trigger: 'change' }
          ],
          'team.member3.name': [
            { required: true, validator: validateMemberRequired('member3', 'name'), message: '请输入姓名', trigger: 'blur' }
          ],
          'team.member3.gender': [
            { required: true, validator: validateMemberRequired('member3', 'gender'), message: '请选择性别', trigger: 'change' }
          ],
          'team.member3.age': [
            { required: true, validator: validateMemberRequired('member3', 'age'), message: '请输入年龄', trigger: 'blur' }
          ],
          'team.member3.duty': [
            { required: true, validator: validateMemberRequired('member3', 'duty'), message: '请输入职务', trigger: 'blur' }
          ],
          'team.member3.idCard': [
            { required: true, validator: validateMemberIdCard('member3'), message: '请输入正确的身份证号码', trigger: 'blur' }
          ],
          'team.member3.phone': [
            { required: true, validator: validateMemberPhone('member3'), message: '请输入正确的手机号码', trigger: 'blur' }
          ],
          'team.member3.sycm': [
            { required: true, validator: validateMemberRequired('member3', 'sycm'), message: '请输入上衣尺码', trigger: 'change' }
          ],
        }
      }
    }
  },
  mounted() {
    console.log(process.env, 111111)
  },
  methods: {
    confirmGroup(type) {
      this.cszb = type
      this.dialogVisible = false
      this.isRead = true
    },
    handleTypeChange() {
      this.activeTab = 'member1'
    },
    submitForm() {
      if (!this.isRead) {
        this.$message.error('请先阅读参赛办法')
        return false
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          let csydyList = [];
          for (let i = 1; i <= 3; i++) {
            let member = this.form.team[`member${i}`]
            csydyList.push(member)
          }
          let data = {
            ...this.form.personal,
            ...this.form.team,
            csydyList,
            cslx: this.form.cslx,
            cszb: this.cszb
          }
          api.submit(data).then(res => {
            if (res.code == 200) {
              this.$message.success('报名成功！')
            }else{
              this.$message.error(res.msg)
            }
          })

        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.activeTab = 'member1'
    }
  }
}
</script>
<style scoped>
.rulesBox {
  color: #00C4C1;
  font-size: 12px;
  text-align: center;
}

.notice-item {
  text-align: justify;
  text-justify: inter-ideograph;
  /* 兼容中文排版 */
  line-height: 1.8;
  /* 可选：增加行高提升可读性 */
}

.el-form-item {
  margin-bottom: 10px;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #00C4C1;
  border-color: #00C4C1;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #00C4C1;
}

::v-deep .el-checkbox__inner::after {
  border-color: #fff;
  border-left: 0;
  border-top: 0;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #00C4C1;
}

.dialog-footer .el-button--primary {
  background: #00C4C1;
  border-color: #00C4C1;
  color: #272727;
}

.main {
  padding: 20px;

  background: linear-gradient(to right rgba(218, 242, 255, 0) 0%, #CAFFFE 15%);
  background: url("../assets/bg.png");
  background-size: 100% 100%
}

.clearfix {
  color: #00C4C1;
  font-weight: bold;
}

.box-card {
  max-width: 800px;
  margin: 0 auto;
}

.form-box {
  margin-top: 30px;
  padding: 20px 10px;
  border-radius: 10px;
  background-color: #fff;
}

.el-divider {
  margin: 30px 0 20px 0;
}
</style>